import React, { createContext, useState, useEffect } from "react";
import mainService from "api/mainService";
import { mainSelectors } from "stores/mainSlice";
import { connect } from "react-redux";
export const CardContext = createContext();

export function CardProviderInner(props) {
  const { children } = props;
  const [cards, setCards] = useState([]);

  useEffect(() => {
    if (props.userSelector) {
      mainService
        .getDashboardData()
        .then((res) => {
          setCards(res.data); // Supponendo che res.data contenga le carte
        })
        .catch((err) => {
          console.log("Errore nel caricamento delle carte", err);
        });
    }
  }, [props.userSelector]);

  return (
    <CardContext.Provider value={{ cards }}>{children}</CardContext.Provider>
  );
}

const mapStateToProps = (state) => {
  return {
    userSelector: mainSelectors.userSelector(state),
  };
};

const mapDispatchToProps = {};

const CardProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(CardProviderInner);

export default CardProvider;
